<template>
	<div class="height-100dvh">
		<div id="hideinlaptop" class="mob-back-header d-flex align-items-center">
			<img
				class="mr-3"
				src="../../assets/mobile/assprog/mobileBackArrow.svg"
				alt=""
				@click="$router.go(-1)"
			/>
			Become a Panelist
		</div>
		<main class="exper-main-container w-100">
			<div id="hideinmobile" class="cand-header d-flex mb-2">
				<img
					class="mr-3 d-flex pointer"
					src="../../assets/img/homepage/back-arrow-blue.svg"
					@click="$router.go(-1)"
					alt=""
				/>
				Become a panelist
			</div>
			<div class="exper-down-cont">
				<section class="exper-left-cont">
					<section class="exper-left-cont-overflow">
						<h2 class="fam-mont text-blue fw-M exper-fs-32 mb-0">
							Choose your expertise
						</h2>
						<h5 class="fam-lato text-darkgrey fw-R exper-fs-20 z-ind-2 mb-0">
							Select your industry and skills. where your interview
							opportunities and process will align with your expertise.
						</h5>
						<div class="exper-radio">
							<label>Select Industry<span class="asterik">*</span></label>
							<div
								v-closable="{
									exclude: ['ref1', 'ref2'],
									handler: 'showIndustry',
								}"
								class="exper-dropdown"
							>
								<div
									ref="ref1"
									@click="toggleDropdown"
									class="exper-selected text-truncate"
									:class="selectedIndustry ? '' : 'text-888888'"
								>
									{{
										selectedIndustry
											? selectedIndustry.industryName
											: "Select option"
									}}
								</div>
								<div @click="toggleDropdown" class="exper-drop-arrow">
									<img
										:class="opendropdown ? 'rotate180' : ''"
										src="../../assets/newdesign/assessPro/bluedownarrow.svg"
										alt=""
									/>
								</div>
								<article ref="ref2" v-if="opendropdown" class="search-dropdown">
									<img
										style="position: absolute; left: 7px; top: 8px"
										src="../../assets/mobile/assprog/search.svg"
										alt=""
									/>
									<b-form-input
										type="text"
										v-model="searchQuery"
										placeholder="Search industry..."
										class="exper-ind-search"
									></b-form-input>
									<div
										v-if="filteredIndustries.length"
										class="custom-radio-list"
									>
										<div
											v-for="(ind, i) in filteredIndustries"
											:key="ind.industryName"
											ref="industryOption"
											class="custom-option"
											:class="{
												'focused-option': focusedIndex === i,
												'selected-option': selectedIndustry === ind,
											}"
											@click="selectIndustry(ind)"
										>
											{{ ind.industryName }}
										</div>
									</div>
									<p
										v-else
										class="text-headtext fam-lato text-center fs-12 mt-3"
									>
										Search not found
									</p>
								</article>
							</div>
						</div>
						<div v-if="availableSkills.length">
							<label class="fam-mont fs-16 fw-LM text-344054"
								>Select Skill(s)<span class="asterik">*</span></label
							>
							<div class="d-flex flex-wrap gap-3 exper-tags-scroll">
								<article
									v-for="(skill, index) in availableSkills"
									:key="index"
									:class="
										selectedSkills.some(
											(s) => s.toLowerCase() === skill.toLowerCase()
										)
											? 'exper-skill-sel'
											: 'exper-skill'
									"
									class="text-break"
									@click="toggleSkill(skill)"
								>
									<img
										v-if="
											selectedSkills.some(
												(s) => s.toLowerCase() === skill.toLowerCase()
											)
										"
										src="../../assets/newdesign/BecomePanelist/round-white-tick.svg"
										alt=""
									/>
									<img
										v-else
										src="../../assets/newdesign/BecomePanelist/blue-circle.svg"
										alt=""
									/>
									{{ skill }}
									<div
										v-if="manuallyAddedSkills.includes(skill)"
										@click.stop="removeSkill(skill)"
									>
										✖
									</div>
								</article>
								<article
									class="exper-skill"
									@click="(addOther = true), (otherSkill = null)"
								>
									<img
										src="../../assets/newdesign/BecomePanelist/skill-plus.svg"
										alt=""
									/>
									Others
								</article>
								<article
									v-if="addOther || isDuplicate"
									class="exper-skill position-relative"
									:class="isDuplicate ? 'error' : ''"
								>
									<img
										v-if="otherSkill"
										@click="toggleNewSkill(otherSkill)"
										class="pointer"
										src="../../assets/newdesign/BecomePanelist/blue-circle.svg"
										alt=""
									/>
									<div class="add-skill">
										<b-form-input
											autofocus
											v-model="otherSkill"
											@keyup.enter="handleEnterKey"
											@input="checkSkillExists"
										></b-form-input>
									</div>
									<img
										@click="removeInput()"
										src="../../assets/newdesign/BecomePanelist/add-circle.svg"
										alt=""
									/>
									<p autofocus v-if="isDuplicate" class="candash-errortxt mb-0">
										Duplicate Skill
									</p>
								</article>
							</div>
						</div>
						<section id="hideinlaptop" class="exper-back-img-size">
							<img
								class="h-100 w-100"
								src="../../assets/newdesign/BecomePanelist/exper-back.svg"
								alt=""
							/>
						</section>
					</section>
					<b-button
						id="hideinmobile"
						@click="submitSelection()"
						:disabled="selectedSkills.length == 0"
						class="candash-addBtn mt-4 w-50"
						>Proceed</b-button
					>
				</section>
				<section id="hideinmobile" class="exper-back-img-size">
					<img
						class="h-100 w-100"
						src="../../assets/newdesign/BecomePanelist/exper-back.svg"
						alt=""
					/>
				</section>
			</div>
			<footer id="hideinlaptop">
				<b-button
					:disabled="selectedSkills.length == 0"
					@click="submitSelection()"
					class="candash-addBtn w-100"
					>Proceed</b-button
				>
			</footer>
		</main>
	</div>
</template>

<script>
import {
	getIndustries,
	postPanelInformation,
	postLinkedinUrl,
	getCvsDetails,
	postPanelResult,
} from "../../utils/apiFunctions";
import successModal from "../../components/mixin/toast";
import mobHeader from "@/components/fixedcomponents/mobileHeader.vue";
import { mapGetters } from "vuex";
import { trackPanelApplied } from '@/utils/posthogHelpers';
export default {
	data() {
		return {
			existingSkill: [],
			industries: [],
			selectedIndustry: null,
			availableSkills: [],
			selectedSkills: [],
			manuallyAddedSkills: [],
			opendropdown: false,
			addOther: false,
			otherSkill: null,
			linkedInUrl: null,
			isDuplicate: false,
			searchQuery: "",
			focusedIndex: -1,
		};
	},
	mixins: [successModal],
	components: {
		mobHeader,
	},
	mounted() {
		this.linkedInUrl = this.$route.query.linkedInUrl || null;
	},
	created() {
		this.fetchPanelResults();
		this.fetchPanelStat();
		this.fetchIndustries();
	},
	watch: {
		searchQuery() {
			this.focusedIndex = -1;
		},
		opendropdown(newVal) {
			if (newVal) {
				this.$nextTick(() => {
					window.addEventListener("keydown", this.handleKeydown);
				});
			} else {
				window.removeEventListener("keydown", this.handleKeydown);
				this.focusedIndex = -1;
			}
		},
	},
	computed: {
		...mapGetters("userVUEX", ["getUserInfo"]),
		userInfo() {
			return this.getUserInfo || {};
		},
		filteredIndustries() {
			return this.industries.filter((ind) =>
				ind.industryName.toLowerCase().includes(this.searchQuery.toLowerCase())
			);
		},
	},
	methods: {
		async fetchPanelResults() {
			try {
				let payload = {
					userID: this.userInfo.userID,
				};
				const response = await postPanelResult(payload);
				if (response.status === 200) {
					const reDate = response.data.data.rejoinDate;
					const rejoinDateNew = new Date(reDate);
					const currentDate = new Date();
					this.results = response.data.data.result;

					if (
						(this.results === "selected" || this.results === "rejected") &&
						rejoinDateNew >= currentDate
					) {
						this.$router.push({
							name: "ResultDashboard",
						});
					}
				}
			} catch (error) {
				console.error("Error fetching:", error);
			}
		},
		async fetchIndustries() {
			try {
				const response = await getIndustries();
				if (response.status === 200) {
					this.industries = Array.isArray(response.data.data.data)
						? response.data.data.data
						: [];
				}
			} catch (error) {
				console.error("Error fetching industries:", error);
			}
		},
		async submitSelection() {
			if (!this.selectedIndustry || this.selectedSkills.length === 0) {
				alert("Please select an industry and at least one skill.");
				return;
			}

			const payload = {
				skills: this.selectedSkills,
				industry: this.selectedIndustry.industryID || this.selectedIndustry.id,
			};
			try {
				const response = await postPanelInformation(payload);
				if (response.status === 200) {
					if (this.linkedInUrl) {
						await this.postUrl();
					} else {
						this.goToApplication();
					}
					// this.$nextTick(() => {
					// 	this.successModal("Success", "Achievement has been added");
					// });
					trackPanelApplied({
						email: this.getUserInfo.email
					})
				} else {
					alert("Submission failed.");
				}
			} catch (error) {
				console.error("Error submitting data:", error);
			}
		},
		async postUrl() {
			try {
				let payload = {
					link: this.linkedInUrl,
				};
				const res = await postLinkedinUrl(payload);
				if (res.status == 200) {
					this.goToApplication();
				}
			} catch (error) {
				console.log(error);
			}
		},

		async fetchPanelStat() {
			try {
				const res = await getCvsDetails();
				if (res.status == 200) {
					this.$router.push({
						name: "ApplicationResult",
					});
				}
			} catch (error) {
				console.log(error);
			}
		},
		selectIndustry(ind) {
			this.selectedIndustry = ind;
			this.handleIndustrySelect(); // your original logic with skills
		},
		handleIndustrySelect() {
			if (this.selectedIndustry) {
				this.availableSkills = this.selectedIndustry.skills || [];
				this.existingSkill = this.availableSkills;
				this.selectedSkills = []; // Reset skills selection
			}
			this.opendropdown = false;
		},
		handleKeydown(event) {
			if (!this.opendropdown) return;

			const options = this.filteredIndustries;
			if (!options.length) return;

			if (event.key === "ArrowDown") {
				event.preventDefault();
				this.focusedIndex = (this.focusedIndex + 1) % options.length;
				this.selectedIndustry = options[this.focusedIndex];
				this.$nextTick(() => {
					const el = this.$refs.industryOption?.[this.focusedIndex];
					el?.scrollIntoView({ block: "nearest", behavior: "smooth" });
				});
			} else if (event.key === "ArrowUp") {
				event.preventDefault();
				this.focusedIndex =
					(this.focusedIndex - 1 + options.length) % options.length;
				this.selectedIndustry = options[this.focusedIndex];
				this.$nextTick(() => {
					const el = this.$refs.industryOption?.[this.focusedIndex];
					el?.scrollIntoView({ block: "nearest", behavior: "smooth" });
				});
			} else if (event.key === "Enter") {
				if (this.focusedIndex >= 0) {
					this.selectIndustry(this.filteredIndustries[this.focusedIndex]);
				}
			}
		},
		toggleSkill(skill) {
			const skillIndex = this.selectedSkills.findIndex(
				(s) => s.toLowerCase() === skill.toLowerCase()
			);

			if (skillIndex === -1) {
				// Add skill if not already selected
				this.selectedSkills.push(skill);
			} else {
				// Remove skill if it is already selected
				this.selectedSkills.splice(skillIndex, 1);

				// If skill was manually added, remove it from availableSkills too
				if (this.manuallyAddedSkills.includes(skill)) {
					this.availableSkills = this.availableSkills.filter(
						(s) => s.toLowerCase() !== skill.toLowerCase()
					);
					this.manuallyAddedSkills = this.manuallyAddedSkills.filter(
						(s) => s.toLowerCase() !== skill.toLowerCase()
					);
				}
			}
		},
		toggleNewSkill(skill) {
			this.selectedSkills.push(skill);

			// Convert skill to lowercase for case-insensitive comparison
			const lowerCaseSkill = skill.toLowerCase();

			// Find existing skill in availableSkills (case-insensitive match)
			const existingSkill = this.availableSkills.find(
				(s) => s.toLowerCase() === lowerCaseSkill
			);

			if (existingSkill) {
				// If skill already exists (case-insensitive), use existing skill
				skill = existingSkill;
			} else {
				// Otherwise, add new skill to availableSkills
				//new skills array this
				this.availableSkills.push(skill);
				this.manuallyAddedSkills.push(skill);
				console.log("manual", this.manuallyAddedSkills);
			}

			//this.otherSkill = null;
			this.addOther = false;
		},
		checkSkillExists() {
			this.addOther = true;
			this.isDuplicate = this.manuallyAddedSkills.some(
				(skill) => skill.toLowerCase() === this.otherSkill.toLowerCase().trim()
			);
		},
		handleEnterKey() {
			if (this.otherSkill && this.otherSkill.trim() !== "") {
				const skillName = this.otherSkill.trim().toLowerCase();

				// Check if skill already exists in selectedSkills (case-insensitive)
				const existsInSelected = this.selectedSkills.some(
					(s) => s.toLowerCase() === skillName
				);

				// Prevent adding duplicate skill
				if (!existsInSelected) {
					this.toggleNewSkill(this.otherSkill.trim());
				} else {
					this.isDuplicate = true; // Show error message if needed
				}
			}
		},
		removeSkill(skill) {
			this.selectedSkills = this.selectedSkills.filter((s) => s !== skill);
			this.availableSkills = this.availableSkills.filter((s) => s !== skill);
			this.manuallyAddedSkills = this.manuallyAddedSkills.filter(
				(s) => s !== skill
			);
		},
		showIndustry() {
			this.opendropdown = false;
		},
		toggleDropdown() {
			this.opendropdown = !this.opendropdown;
			this.searchQuery = "";

			this.$nextTick(() => {
				if (this.opendropdown && this.selectedIndustry) {
					const selectedIndex = this.filteredIndustries.findIndex(
						(ind) => ind.industryName === this.selectedIndustry.industryName
					);

					if (selectedIndex !== -1) {
						this.focusedIndex = selectedIndex;

						const el = this.$refs.industryOption?.[selectedIndex];
						el?.scrollIntoView({ block: "nearest", behavior: "smooth" });
					}
				}
			});
		},
		goToApplication() {
			this.$router.push({
				name: "ApplicationResult",
			});
		},

		removeInput() {
			this.addOther = false;
			this.otherSkill = null;
			this.isDuplicate = false;
		},
	},
};
</script>

<style>
.exper-main-container {
	background-color: #e9ecef;
	height: calc(100vh - 60px);
	padding: 15px 15px 15px 75px;
	top: 60px;
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
}
.exper-down-cont {
	height: calc(100vh - 100px);
	overflow: auto;
	border-radius: 8px;
	background-color: #f0f5ff;
	border: 1px solid #8c8c8c54;
	box-shadow: 0px 4px 8px 0px #0000002b;
	display: flex;
	justify-content: space-between;
	max-width: 1825px;
	width: 100%;
}

.exper-back-img-size {
	height: calc(100vh - 151px);
}
.exper-left-cont {
	padding: 10px 30px;
	width: 55%;

	margin-top: 20px;
}
.exper-left-cont-overflow {
	display: flex;
	flex-direction: column;
	gap: 20px;
	height: calc(100vh - 252px);
}
.exper-tags-scroll {
	min-height: auto;
	max-height: calc(100vh - 520px);
	overflow: auto;
	position: relative;
	z-index: 3;
	padding-bottom: 2px;
}
.exper-left-cont::-webkit-scrollbar-track {
	background: transparent;
	border-radius: 15px;
}
.exper-left-cont::-webkit-scrollbar-thumb {
	box-shadow: none;
}
.exper-radio label {
	font-family: "Montserrat", sans-serif;
	font-size: 16px;
	font-weight: 500;
	color: #344054;
}
.exper-dropdown {
	box-shadow: 0px 1px 2px 0px #1018280d;
	border: 1px solid #20639b;
	border-radius: 8px;
	height: 40px;
	width: 75%;
	background-color: #ffffff;
	position: relative;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding-inline: 15px;
	cursor: pointer;
}
.exper-dropdown .search-dropdown {
	position: absolute;
	width: 100%;
	top: 42px;
	z-index: 4;
	border: 1px solid #d7d3fe;
	border-radius: 8px;
	left: 0px;
	background-color: #ffffff;
	overflow: hidden;
}
.exper-dropdown .form-group {
	max-height: 143px;
	overflow: auto;
	margin-bottom: 0;
}
.exper-dropdown .form-group::-webkit-scrollbar {
	scroll-behavior: smooth !important;
	width: 5px !important;
	min-height: 40px !important;
	background-color: transparent !important;
}
.exper-dropdown .form-group::-webkit-scrollbar-thumb {
	height: 20px;
}
.exper-ind-search {
	height: 32px;
	background-color: #ececec;
	font-size: 12px;
	padding: 10px 10px 10px 26px;
	border-radius: 7px;
	border: none;
}
.exper-ind-search:focus {
	box-shadow: none;
	background-color: #ececec;
}
.exper-dropdown .btn-group-vertical {
	width: 100%;
}
.exper-drop-arrow {
	width: 10%;
	height: 37px;
	display: flex;
	align-items: center;
	justify-content: flex-end;
}
.exper-dropdown .btn-secondary {
	background-color: #f9f9f9;
	border-color: #f9f9f9;
	font-size: 11px;
	color: #333;
	font-weight: 600;
	font-family: "Lato", sans-serif;
	border: none;
	text-align: left;
	padding: 8px 12px;
}
.exper-dropdown .btn-secondary:hover {
	color: #333;
	background-color: #e8eff4;
	border-color: #e8eff4;
}

.exper-dropdown .btn-secondary:not(:disabled):not(.disabled):active,
.exper-dropdown .btn-secondary:not(:disabled):not(.disabled).active,
.show > .exper-dropdown .btn-secondary.dropdown-toggle {
	color: #333;
	background-color: #c8d9e5;
	border-color: #c8d9e5;
}
.exper-dropdown .btn-secondary:focus,
.exper-dropdown .btn-secondary.focus {
	box-shadow: none;
}
.exper-selected {
	font-family: "Montserrat", sans-serif;
	font-size: 14px;
	font-weight: 500;
	color: #333333;
	width: 90%;
	height: 37px;
	align-items: center;
	display: flex;
}
.exper-skill {
	box-shadow: 0px 1px 2px 0px #1018280d;
	border: 1px solid #8c8c8c4d;
	background-color: #ffffff;
	border-radius: 25px;
	padding: 5px 12px;
	font-family: "Lato", sans-serif;
	font-size: 16px;
	font-weight: 400;
	color: #333333;
	display: flex;
	align-items: center;
	gap: 8px;
	cursor: pointer;
}
.exper-skill-sel {
	box-shadow: 0px 1px 2px 0px #1018280d;
	border: 1px solid #8c8c8c4d;
	background-color: #009045;
	border-radius: 25px;
	padding: 5px 12px;
	font-family: "Lato", sans-serif;
	font-size: 16px;
	font-weight: 400;
	color: #ffffff;
	display: flex;
	align-items: center;
	gap: 8px;
	cursor: pointer;
}
.exper-fs-32 {
	font-size: 32px;
}

.exper-fs-20 {
	font-size: 20px;
}
@media only screen and (max-width: 1028px) {
	.exper-radio {
		position: relative;
		z-index: 5;
	}
	.exper-main-container {
		background-color: #e9ecef;
		height: calc(
			100dvh - (60px + env(safe-area-inset-top) + env(safe-area-inset-bottom))
		);
		padding: 0px;
		overflow: auto;
		/* position: fixed; */
		top: unset;
		display: block;
	}
	.exper-down-cont {
		height: 92%;
		border-radius: 0px;
		background-color: #e9ecef;
		border: none;
		box-shadow: none;
	}
	.exper-left-cont {
		padding: 30px 15px 15px 15px;
		width: 100%;
		overflow: hidden;
		margin-top: unset;
		position: relative;
	}
	.exper-left-cont-overflow {
		height: 100%;
	}
	.exper-tags-scroll {
		min-height: auto;
		max-height: calc(100vh - (448px + env(safe-area-inset-bottom)));
		overflow: auto;
	}
	.exper-main-container footer {
		background-color: #f9fafb;
		height: 8%;
		padding-inline: 15px;
		display: flex;
		align-items: center;
	}
	.exper-back-img-size {
		height: unset;
		position: absolute;
		right: -9px;
		top: 0px;
		width: 47%;
		z-index: 1;
	}
	.exper-skill {
		font-size: 13px;
		z-index: 2;
		position: relative;
	}
	.exper-skill-sel {
		font-size: 13px;
		z-index: 2;
		position: relative;
	}
	.exper-fs-32 {
		font-size: 20px;
	}
	.exper-fs-20 {
		font-size: 14px;
		width: 65%;
	}
	.exper-dropdown {
		width: 100%;
		z-index: 2;
	}
}
.add-skill {
	width: 150px;
}
.add-skill .form-control {
	display: block;
	width: 100%;
	border: none;
	height: calc(1.5em + 0.025rem) !important;
	border-bottom: 1px solid #8c8c8cb2;
	padding: 0 !important;
	font-size: 1rem;
	font-weight: 400;
	color: #495057;
	background-color: #fff;
	background-clip: padding-box;
	border-radius: 0;
}
.add-skill .form-control:focus {
	box-shadow: unset;
}
.custom-option {
	padding: 8px 10px;
	font-size: 11px;
	color: #333;
	font-weight: 600;
	font-family: "Lato", sans-serif;
	cursor: pointer;
}
.custom-option:hover {
	background-color: #e8eff4;
}
.focused-option {
	background-color: #c8d9e5;
}
.selected-option {
	background-color: #c8d9e5;
}
.custom-radio-list {
	min-height: auto;
	max-height: 200px;
	overflow: auto;
}
</style>
